export const environment = {
  production: false,
  apiBaseUrl: 'https://residentapis.yottareal.com/',
  //apiBaseUrl: 'http://localhost/Cybersoft.YottaResident.WebAPIs/',
  interactiveMapUrl: 'https://adaraportal.yottareal.com/interactivemappages/',
  dbaId: 0,
  googleMapsApiKey: 'AIzaSyDUE2td55q8Pob12SEEqcpn0Vw69kjurCY',
  username: 'DBAPortalUser',
  password: 'DBAP0rta1P@ssw0rd',
  azureTranslator: {
    endpoint: 'https://api.cognitive.microsofttranslator.com',
    key: 'Fcqbv0Nebes6BZ6ATEsM2QpqVhtT27UFDnSIV29luN7KSgYGuPAwJQQJ99BLACHYHv6XJ3w3AAAbACOGne7u',
    region: 'eastus2'
  }
};
